import { COLORS } from '@/constants';
import styled from 'styled-components';
import Link from 'next/link';

export const Table = styled.div`
  display: flex;
  flex-direction: column;
  border-radius: 8px;
  border: 1px solid ${COLORS['neutral/300']};
  overflow: hidden;
`;

const GRID_COLS = '2fr 1.5fr 0.8fr 1.2fr 24px';

export const TableHead = styled.div`
  display: grid;
  grid-template-columns: ${GRID_COLS};
  gap: 12px;
  padding: 8px 16px;
  background: ${COLORS['neutral/100']};

  @media (max-width: 640px) {
    display: none;
  }
`;

const tableRowBase = `
  display: grid;
  grid-template-columns: ${GRID_COLS};
  gap: 12px;
  padding: 8px;
  align-items: center;
  border-top: 1px solid ${COLORS['neutral/200']};
  text-decoration: none;
  color: inherit;

  & > * {
    min-width: 0;
  }

  @media (max-width: 640px) {
    display: grid;
    grid-template-columns: 44px 1fr 16px;
    grid-template-rows: auto;
    gap: 0 10px;
    padding: 10px 12px;
    align-items: center;
  }
`;

export const TableRowStatic = styled.div`
  ${tableRowBase}
  opacity: 0.55;
`;

export const TableRowLink = styled(Link)`
  ${tableRowBase}
  transition: background 0.15s;
  cursor: pointer;

  &:hover {
    background: ${COLORS['neutral/50']};
  }

  &:hover .row-title {
    color: ${COLORS['blue-light-2']};
    text-decoration: underline;
  }
`;

export const RowThumb = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 6px;
  overflow: hidden;
  flex-shrink: 0;
  background: ${COLORS['neutral/200']};

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

export const RowTitleCell = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;

  @media (max-width: 640px) {
    display: none;
  }
`;

export const RowMobileStats = styled.div`
  display: none;

  @media (max-width: 640px) {
    display: flex;
    flex-direction: column;
    gap: 2px;
    min-width: 0;
    grid-column: 2;
  }
`;

export const RowArrow = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  @media (max-width: 640px) {
    grid-column: 3;
    grid-row: 1;
  }
`;

export const RowMobileThumb = styled.div`
  display: none;

  @media (max-width: 640px) {
    display: block;
    width: 44px;
    height: 44px;
    border-radius: 6px;
    overflow: hidden;
    flex-shrink: 0;
    background: ${COLORS['neutral/200']};
    grid-column: 1;
    grid-row: 1;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`;

export const ProjectTitleLink = styled(Link)`
  color: ${COLORS['blue-light-2']};
  text-decoration: underline !important;
  text-decoration-thickness: 2px;
  text-underline-offset: 3px;
`;

export const ShowMoreButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  color: ${COLORS['primary/600']};
  font-size: 14px;
  font-weight: 600;
  padding: 12px 16px;
  text-align: center;
  width: 100%;
  border-top: 1px solid ${COLORS['neutral/200']};

  &:hover {
    color: ${COLORS['primary/800']};
    background: ${COLORS['neutral/50']};
  }
`;
